export default class DocumentIndexObserver {
  constructor(element) {
    this.element = element;
    this.links = this.element.querySelectorAll('a');
    this.offset = 20; // 20px offset
  }

  init() {
    //console.log('DocumentIndex observer initialized');
    this.links.forEach(link => {
      link.addEventListener('click', this.handleLinkClick.bind(this));
    });
  }

  handleLinkClick(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      this.scrollToTarget(targetElement);
    }
  }

  scrollToTarget(targetElement) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - this.offset;
    
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  destroy() {
    console.log('DocumentIndex observer destroyed');
    this.links.forEach(link => {
      link.removeEventListener('click', this.handleLinkClick.bind(this));
    });
  }
}